import { ComponentProps } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $rotation: number }>`
  transform: rotate(${({ $rotation }) => $rotation}deg);
  transform-origin: center;
`;

// DATA

// TYPES
export interface Props extends ComponentProps<"svg"> {
  orientation?: ArrowOrientation | number;
}

export type ArrowOrientation = "down" | "up" | "left" | "right";

// CONSTANTS
const orientationMap: Record<ArrowOrientation, number> = {
  down: 270,
  up: 90,
  left: 0,
  right: 180,
};

// FUNCTIONS
export const getRotation = (orientation: ArrowOrientation | number) => {
  const rotation =
    typeof orientation === "number"
      ? orientation
      : orientationMap[orientation] || 0;

  return { rotation };
};

// ASSETS
